import { Theme } from '@shipengine/giger-theme';
import { css } from '@emotion/react';

export function getOnboardingLayoutStyles(theme: Theme) {
    return css({
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        padding: theme.spacing(3),
        backgroundColor: theme.palette.gray.ultraLight,
    });
}

export function getHeaderStyles(theme: Theme) {
    return css({
        display: 'none',
        padding: theme.spacing(3),

        [theme.mediaQuery('tablet')]: {
            display: 'block',
        },
    });
}

export function getOnboardingLogoStyles(theme: Theme) {
    return css({
        height: theme.spacing(5),
    });
}
